import { render, staticRenderFns } from "./RegistryDocumentValueView.vue?vue&type=template&id=03b5eebf&"
import script from "./RegistryDocumentValueView.vue?vue&type=script&lang=js&"
export * from "./RegistryDocumentValueView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports